/**
 * The in-browser engine's own LIFECYCLE (fix F-B / F6, 2026-10-06) — WEB-only,
 * and a SEPARATE store from `analysisStore.ts` on purpose (that one is
 * someone else's file this round; this is not a field to add to it, it is a
 * different concern — whether the worker exists at all, not what it has
 * found).
 *
 * `EngineHost` is the ONLY writer (`onStatus`, wired to
 * `@/Components/StockfishEngine`'s own init / handshake / crash handling) and
 * resets it to 'off' on unmount; `AnalysisHeader` is the reader. Same shape as
 * `Strip/authStatus.ts`: a web-only transport/lifecycle signal next to the
 * thing that reads it, not in the shared `analysisStore`.
 *
 * 'off' is this store's OWN value — `StockfishEngine` never reports it (its
 * `EngineStatus` type has no such member); it is what "nothing has told us
 * anything yet" and "the worker is gone" both look like.
 */
import {create} from 'zustand';

import type {EngineStatus} from '@/Components/StockfishEngine';

export type EngineStatusStore = {
  status: EngineStatus | 'off';
  /** the underlying error message — only non-empty while status is 'error' */
  detail: string;
  setStatus: (status: EngineStatus, detail?: string) => void;
  reset: () => void;
};

export const useEngineStatus = create<EngineStatusStore>(set => ({
  status: 'off',
  detail: '',
  setStatus: (status, detail = '') => set({status, detail}),
  reset: () => set({status: 'off', detail: ''}),
}));

export default useEngineStatus;
